import { EditCoachModal } from './EditCoachModal';

export default EditCoachModal;
